<automatick-modal-shell [title]="title" size="compact" (dismissed)="onCancel()">
  <p class="confirm-modal__message">{{ message }}</p>

  @if (hasInput) {
    <label class="confirm-modal__field">
      <span class="confirm-modal__input-label">
        {{ inputPlaceholder || title }}
      </span>
      <input
        class="confirm-modal__input"
        type="text"
        [(ngModel)]="editValue"
        [placeholder]="inputPlaceholder"
        (keydown)="onInputKeydown($event)"
        cdkFocusInitial
      />
    </label>
  }

  <div modalActions class="confirm-modal__actions">
    <button
      sch-button
      class="confirm-modal__cancel"
      type="button"
      size="sm"
      variant="outline"
      [attr.cdkFocusInitial]="hasInput ? null : ''"
      (click)="onCancel()"
    >
      {{ cancelLabel }}
    </button>
    <button
      sch-button
      class="confirm-modal__confirm"
      type="button"
      size="sm"
      variant="solid"
      [color]="variant"
      (click)="onConfirm()"
    >
      {{ confirmLabel }}
    </button>
  </div>
</automatick-modal-shell>
